import * as React from "react";
import styled from "styled-components";
import buttonBg from "../assets/images/button_bg.svg";
import { GREEN } from "../constant/Colors";

export const Button = styled.button`
  background: url("${buttonBg}") center no-repeat;
  background-size: contain;
  outline: none;
  border: none;
  color: ${GREEN};
  transition: transform 0.3s ease;
  font-family: Ubuntu;
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  

  :focus {
    border: none;
    outline: none;
  }

  :active {
    border: none;
    outline: none;
    text-decoration: underline;
  }
  
  :hover {
    transform: scale(1.05);
    cursor: pointer;
  }
`;
